import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import initTree from '/builds/gitlab/gitlab-ee/app/assets/javascripts/repository/index.js?vue3';
import repositoryPathMixin from '~/repository/mixins/repository_path';
import CodeOwners from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/vue_shared/components/code_owners/code_owners.vue?vue3';

const initCodeOwnersApp = (router, apolloProvider, projectPath) => {
  const codeOwnersEl = document.querySelector('#js-code-owners');
  if (!codeOwnersEl) return null;

  const { branch, canViewBranchRules, branchRulesPath } = codeOwnersEl.dataset;
  return new Vue({
    el: codeOwnersEl,
    name: 'RepositoryCodeOwnersRoot',
    router,
    apolloProvider,
    mixins: [repositoryPathMixin],
    render(h) {
      return h(CodeOwners, {
        props: {
          filePath: this.computedPath,
          projectPath,
          branch,
          canViewBranchRules,
          branchRulesPath,
        },
      });
    },
  });
};

export default () => {
  const tree = initTree();
  if (!tree) return;

  const { router, apolloProvider, projectPath } = tree;

  initCodeOwnersApp(router, apolloProvider, projectPath);
};
